import React, {Component} from 'react';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonItem,
  IonList, IonListHeader,
  IonMenuButton,
  IonPopover,
  IonSearchbar,
  IonTitle,
  IonToggle,
  IonToolbar
} from '@ionic/react';
import "../ContestDetailPage.css"
import {History} from 'history';
import {SearchbarChangeEventDetail} from '@ionic/core';
import DressageProtocol from "../../domain/DressageProtocol";

type Props = SearchProps & {
  history: History;
  canGoBack: boolean;
};

type State = {
  popUpOpen: boolean;
  isChecked: boolean
}

export type SearchProps = {
  title?: string;
  dressageProtocol?: DressageProtocol;
  searchBarEnabled: boolean;
  onSearchChanged?: (value: string | undefined) => void;
  searchValue?: string;
  onToggleImageVisibility?: (shouldBeVisible: boolean) => void,
  initialChecked?: boolean
}

export default class DressageProtocolDetailHeader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      popUpOpen: false,
      isChecked: props.initialChecked || false
    };
  }

  render() {
    let infoButton = null;
    let toggle = null;
    if (this.props.dressageProtocol) {
      infoButton = (
        <IonButton onClick={() => this.setState({popUpOpen: true})}>
          <IonIcon name={"information-circle-outline"}/>
        </IonButton>
      );
      const onToggleImageVisibility = this.props.onToggleImageVisibility;
      toggle = (
        <IonToggle slot={"end"} checked={this.state.isChecked} onIonChange={value => {
          this.setState({isChecked: !this.state.isChecked});
          if (this.props.onToggleImageVisibility !== undefined) {
            this.props.onToggleImageVisibility(value.detail.checked)
          }
        }}/>
      )
    }
    return (
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            {this.renderBackButton()}
            {this.renderMenuButton()}
          </IonButtons>
          <IonButtons slot="end">
            {infoButton}
            {toggle}
          </IonButtons>
          {this.renderTitle()}
          {this.renderSearchBar()}
        </IonToolbar>
        {this.props.children}
        {this.renderInfoPopup()}
      </IonHeader>
    );
  }

  private renderMenuButton() {
    if (!this.props.canGoBack) {
      return (
        <IonMenuButton/>
      );
    }
  }

  private renderBackButton() {
    if (this.props.canGoBack) {
      return (
        <IonBackButton
          onClick={() => {
            const history = this.props.history;
            history.goBack()
          }}
          defaultHref={'#'}
          goBack={() => console.log("go back is not supported like this (use on click handler)")}/>
      );
    }
  }

  private renderInfoPopup() {
    if (!this.props.dressageProtocol) {
      return null;
    }
    let index = 0;
    return (
      <IonPopover isOpen={this.state.popUpOpen} onDidDismiss={() => this.setState({popUpOpen: false})}>
        <IonList>
          <IonListHeader key={index++}>{this.props.dressageProtocol!.series}</IonListHeader>
          <IonItem key={index++}>{this.props.dressageProtocol!.protocolNumber}</IonItem>
          <IonItem key={index++}>{this.props.dressageProtocol!.period}</IonItem>
          <IonItem key={index++}>{this.props.dressageProtocol!.arenaDimensions}</IonItem>
          <IonItem key={index++}>{this.props.dressageProtocol!.remarks}</IonItem>
        </IonList>
      </IonPopover>
    )
  }

  private renderTitle() {
    if (!this.props.title) {
      return null;
    }

    return (
      <IonTitle>{this.props.title}</IonTitle>
    );
  }

  private renderSearchBar() {
    if (!this.props.searchBarEnabled) {
      return null;
    }
    return (
      <IonSearchbar
        onIonChange={
          (event: CustomEvent<SearchbarChangeEventDetail>) =>
            this.props.onSearchChanged
              ? this.props.onSearchChanged(event.detail.value)
              : () => {
              }
        }
        value={this.props.searchValue}
      >&nbsp;</IonSearchbar>
    );
  }
}
